  
export const fiveMinuteSlots = [
  {
    id: 1,
    start: "09:00",
    end: "09:05",
    time: "09:00 - 09:05",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 2,
    start: "09:05",
    end: "09:10",
    time: "09:05 - 09:10",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 3,
    start: "09:10",
    end: "09:15",
    time: "09:10 - 09:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 4,
    start: "09:15",
    end: "09:20",
    time: "09:15 - 09:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 5,
    start: "09:20",
    end: "09:25",
    time: "09:20 - 09:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 6,
    start: "09:25",
    end: "09:30",
    time: "09:25 - 09:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 7,
    start: "09:30",
    end: "09:35",
    time: "09:30 - 09:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 8,
    start: "09:35",
    end: "09:40",
    time: "09:35 - 09:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 9,
    start: "09:40",
    end: "09:45",
    time: "09:40 - 09:45",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 10,
    start: "09:45",
    end: "09:50",
    time: "09:45 - 09:50",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 11,
    start: "09:50",
    end: "09:55",
    time: "09:50 - 09:55",
    length: "5",
    type: "BREAK",
    booked: false,
  },
  {
    id: 12,
    start: "09:55",
    end: "10:00",
    time: "09:55 - 10:00",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 13,
    start: "10:00",
    end: "10:05",
    time: "10:00 - 10:05",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 14,
    start: "10:05",
    end: "10:10",
    time: "10:05 - 10:10",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 15,
    start: "10:10",
    end: "10:15",
    time: "10:10 -10:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 16,
    start: "10:15",
    end: "10:20",
    time: "10:15 - 10:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 17,
    start: "10:20",
    end: "10:25",
    time: "10:20 - 10:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 18,
    start: "10:25",
    end: "10:30",
    time: "10:25 - 10:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 19,
    start: "10:30",
    end: "10:35",
    time: "10:30 -10:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 20,
    start: "10:35",
    end: "10:40",
    time: "10:35 -10:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 21,
    start: "10:40",
    end: "10:45",
    time: "10:40 -10:45",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 22,
    start: "10:45",
    end: "10:55",
    time: "10:45 - 10:55",
    length: "10",
    type: "BREAK",
    booked: false,
  },
  {
    id: 23,
    start: "10:55",
    end: "11:00",
    time: "10:55 - 11:00",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 24,
    start: "11:00",
    end: "11:05",
    time: "11:00 - 11:05",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 25,
    start: "11:05",
    end: "11:10",
    time: "11:0 - 11:10",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 26,
    start: "11:10",
    end: "11:15",
    time: "11:10 -11:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 27,
    start: "11:15",
    end: "11:20",
    time: "11:15 - 11:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 28,
    start: "11:20",
    end: "11:25",
    time: "11:20 - 11:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 29,
    start: "11:25",
    end: "11:30",
    time: "11:25 - 11:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 30,
    start: "11:30",
    end: "11:35",
    time: "11:30 -11:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 31,
    start: "11:35",
    end: "11:40",
    time: "11:35 -11:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 32,
    start: "11:40",
    end: "11:45",
    time: "11:40 -11:45",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 33,
    start: "11:45",
    end: "11:50",
    time: "11:45 - 11:50",
    length: "5",
    type: "BREAK",
    booked: false,
  },
  {
    id: 34,
    start: "11:50",
    end: "11:55",
    time: "11:50 - 11:55",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 35,
    start: "11:55",
    end: "12:00",
    time: "11:55 - 12:00",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 36,
    start: "12:00",
    end: "12:05",
    time: "12:00 - 12:05",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 37,
    start: "12:05",
    end: "12:10",
    time: "12:05 - 12:10",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 38,
    start: "12:10",
    end: "12:15",
    time: "12:10 - 12:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 39,
    start: "12:15",
    end: "11:20",
    time: "12:15 - 12:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 40,
    start: "12:20",
    end: "11:25",
    time: "12:20 - 12:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 41,
    start: "12:25",
    end: "12:30",
    time: "12:25 - 12:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 42,
    start: "12:30",
    end: "12:35",
    time: "12:30 - 12:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 43,
    start: "12:35",
    end: "12:40",
    time: "12:35 - 12:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 44,
    start: "12:40",
    end: "13:10",
    time: "12:40 - 13:10",
    length: "30",
    type: "BREAK",
    booked: false,
  },
  {
    id: 45,
    start: "13:10",
    end: "13:15",
    time: "13:10 - 13:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 46,
    start: "13:15",
    end: "13:20",
    time: "13:15 - 13:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 47,
    start: "13:20",
    end: "13:25",
    time: "13:20 - 13:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 48,
    start: "13:25",
    end: "13:30",
    time: "13:25 - 13:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 49,
    start: "13:30",
    end: "13:35",
    time: "13:30 - 13:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 50,
    start: "13:35",
    end: "13:40",
    time: "13:30 - 13:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 51,
    start: "13:40",
    end: "13:45",
    time: "13:30 - 13:45",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 52,
    start: "13:45",
    end: "13:50",
    time: "13:30 - 13:50",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 53,
    start: "13:50",
    end: "13:55",
    time: "13:30 - 13:55",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 54,
    start: "13:55",
    end: "14:00",
    time: "13:55 - 14:00",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 55,
    start: "14:00",
    end: "14:05",
    time: "14:00 - 14:05",
    length: "5",
    type: "BREAK",
    booked: false,
  },
  {
    id: 56,
    start: "14:05",
    end: "14:10",
    time: "14:05 - 14:10",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 57,
    start: "14:10",
    end: "14:15",
    time: "14:10 - 14:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 58,
    start: "14:15",
    end: "14:20",
    time: "14:15 - 14:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 59,
    start: "14:20",
    end: "14:25",
    time: "14:25 - 14:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 60,
    start: "14:25",
    end: "14:30",
    time: "14:25 - 14:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 61,
    start: "14:30",
    end: "14:35",
    time: "14:30 - 14:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 62,
    start: "14:35",
    end: "14:40",
    time: "14:35 - 14:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 63,
    start: "14:40",
    end: "14:45",
    time: "14:40 - 14:45",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 64,
    start: "14:45",
    end: "14:50",
    time: "14:45 - 14:50",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 65,
    start: "14:50",
    end: "14:55",
    time: "14:50 - 14:55",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 66,
    start: "14:55",
    end: "15:05",
    time: "14:55 - 15:05",
    length: "10",
    type: "BREAK",
    booked: false,
  },
  {
    id: 67,
    start: "15:05",
    end: "15:10",
    time: "15:05 - 15:10",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 68,
    start: "15:10",
    end: "15:15",
    time: "15:10 - 15:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 69,
    start: "15:15",
    end: "15:20",
    time: "15:15 - 15:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 70,
    start: "15:20",
    end: "15:25",
    time: "15:20 - 15:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 71,
    start: "15:25",
    end: "15:30",
    time: "15:25 - 15:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 72,
    start: "15:30",
    end: "15:35",
    time: "15:30 - 15:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 73,
    start: "15:35",
    end: "15:40",
    time: "15:35 - 15:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 74,
    start: "15:40",
    end: "15:45",
    time: "15:40 - 15:45",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 75,
    start: "15:45",
    end: "15:50",
    time: "15:45 - 15:50",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 76,
    start: "15:50",
    end: "15:55",
    time: "15:50 - 15:55",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 77,
    start: "15:55",
    end: "16:00",
    time: "15:55 - 16:00",
    length: "5",
    type: "BREAK",
    booked: false,
  },
  {
    id: 78,
    start: "16:00",
    end: "16:05",
    time: "16:00 - 16:05",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 79,
    start: "16:05",
    end: "15:15",
    time: "16:05 - 15:15",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 80,
    start: "16:10",
    end: "15:20",
    time: "16:10 - 15:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 81,
    start: "16:15",
    end: "16:20",
    time: "16:15 - 16:20",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 82,
    start: "16:20",
    end: "16:25",
    time: "16:20 - 16:25",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 83,
    start: "16:25",
    end: "16:30",
    time: "16:25 - 15:30",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 84,
    start: "16:30",
    end: "16:35",
    time: "16:30 - 16:35",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 85,
    start: "16:35",
    end: "16:40",
    time: "16:35 - 16:40",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 86,
    start: "16:40",
    end: "16:45",
    time: "16:40 - 16:45",
    length: "5",
    type: "SLOT",
    booked: false,
  },
  {
    id: 87,
    start: "16:45",
    end: "16:50",
    time: "16:45 - 16:50",
    length: "5",
    type: "SLOT",
    booked: false,
  },
];
export const fifteenMinuteSlots = [
  {
    id: 1,
    start: "09:00",
    end: "09:15",
    time: "09:00 - 09:15",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 2,
    start: "09:15",
    end: "09:30",
    time: "09:15 - 09:30",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 3,
    start: "09:30",
    end: "09:45",
    time: "09:30 - 09:45",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 4,
    start: "09:45",
    end: "10:00",
    time: "09:45 - 10:00",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 5,
    start: "10:00",
    end: "10:15",
    time: "10:00 - 10:15",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 6,
    start: "10:15",
    end: "10:30",
    time: "10:15 - 10:30",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 7,
    start: "10:30",
    end: "11:45",
    time: "10:30 - 11:45",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 8,
    start: "10:45",
    end: "11:00",
    time: "10:45 - 11:00",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 9,
    start: "11:00",
    end: "11:15",
    time: "11:00 - 11:15",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 10,
    start: "11:15",
    end: "11:30",
    time: "11:15 - 11:30",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 11,
    start: "11:30",
    end: "11:45",
    time: "11:30 - 11:45",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 12,
    start: "11:45",
    end: "12:00",
    time: "11:45 - 12:00",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 13,
    start: "12:00",
    end: "12:15",
    time: "12:00 - 12:15",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 14,
    start: "12:15",
    end: "12:30",
    time: "12:15 - 12:30",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 15,
    start: "12:30",
    end: "12:45",
    time: "12:30 - 12:45",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 16,
    start: "12:45",
    end: "13:30",
    time: "12:45 - 13:30",
    length: "45",
    type: "BREAK",
    booked: false,
  },
  {
    id: 17,
    start: "13:30",
    end: "13:45",
    time: "13:30 - 13:45",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 18,
    start: "13:45",
    end: "14:00",
    time: "13:45 - 14:00",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 19,
    start: "14:00",
    end: "14:15",
    time: "14:00 - 14:15",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 20,
    start: "14:15",
    end: "14:30",
    time: "14:15 - 14:30",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 21,
    start: "14:30",
    end: "14:45",
    time: "14:30 - 14:45",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 22,
    start: "14:45",
    end: "15:00",
    time: "14:45 - 15:00",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 23,
    start: "15:00",
    end: "15:15",
    time: "15:00 - 15:15",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 24,
    start: "15:15",
    end: "15:30",
    time: "15:15 - 15:30",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 25,
    start: "15:30",
    end: "15:45",
    time: "15:30 - 15:45",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 26,
    start: "15:45",
    end: "16:00",
    time: "15:45 - 16:00",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 27,
    start: "16:00",
    end: "16:15",
    time: "16:00 - 16:15",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 28,
    start: "16:15",
    end: "16:30",
    time: "16:15 - 16:30",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 29,
    start: "16:30",
    end: "16:45",
    time: "16:30 - 16:45",
    length: "15",
    type: "SLOT",
    booked: false,
  },
  {
    id: 30,
    start: "16:45",
    end: "17:00",
    time: "16:45 - 17:00",
    length: "15",
    type: "SLOT",
    booked: false,
  },
];
export const twentyMinuteSlots = [
  {
    id: 1,
    start: "09:00",
    end: "09:20",
    time: "09:00 - 09:20",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 2,
    start: "09:20",
    end: "09:40",
    time: "09:20 - 09:40",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 3,
    start: "09:40",
    end: "10:00",
    time: "09:40 - 10:00",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 4,
    start: "10:00",
    end: "10:20",
    time: "10:00 - 10:20",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 5,
    start: "10:20",
    end: "10:40",
    time: "10:20 - 10:40",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 6,
    start: "10:40",
    end: "11:00",
    time: "10:40 - 11:00",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 7,
    start: "11:00",
    end: "11:20",
    time: "11:00 - 11:20",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 8,
    start: "11:20",
    end: "11:40",
    time: "11:20 - 11:40",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 9,
    start: "11:40",
    end: "12:00",
    time: "11:40 - 12:00",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 10,
    start: "12:00",
    end: "12:20",
    time: "12:00 - 12:20",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 11,
    start: "12:20",
    end: "12:40",
    time: "12:20 - 12:40",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 12,
    start: "12:40",
    end: "13:10",
    time: "12:40 - 13:10",
    length: "30",
    type: "BREAK",
    booked: false,
  },
  {
    id: 13,
    start: "13:10",
    end: "13:30",
    time: "13:10 - 13:30",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 14,
    start: "13:30",
    end: "13:50",
    time: "13:30 - 13:50",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 16,
    start: "13:50",
    end: "14:10",
    time: "13:50 - 14:10",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 17,
    start: "14:10",
    end: "14:30",
    time: "14:10 - 14:30",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 18,
    start: "14:30",
    end: "14:50",
    time: "14:30 - 14:50",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 19,
    start: "14:50",
    end: "15:10",
    time: "14:50 - 15:10",
    length: "20",
    type: "BREAK",
    booked: false,
  },
  {
    id: 20,
    start: "15:10",
    end: "15:30",
    time: "15:10 - 15:30",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 21,
    start: "15:30",
    end: "15:50",
    time: "15:30 - 15:50",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 22,
    start: "15:50",
    end: "16:10",
    time: "15:50 - 16:10",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 23,
    start: "16:10",
    end: "16:30",
    time: "16:10 - 16:30",
    length: "20",
    type: "SLOT",
    booked: false,
  },
  {
    id: 24,
    start: "16:30",
    end: "16:50",
    time: "16:30: - 16:50",
    length: "20",
    type: "SLOT",
    booked: false,
  }
];
export const thirtyMinuteSlots = [
  {
    id: 1,
    start: "09:00",
    end: "09:30",
    time: "09:00 - 09:30",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 2,
    start: "09:30",
    end: "10:00",
    time: "09:30 - 10:00",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 3,
    start: "10:00",
    end: "10:30",
    time: "10:00 - 10:30",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 4,
    start: "10:30",
    end: "10:45",
    time: "10:30 - 10:45",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 5,
    start: "10:45",
    end: "11:15",
    time: "10:45 - 11:15",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 6,
    start: "11:15",
    end: "11:45",
    time: "11:15 - 11:45",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 7,
    start: "11:45",
    end: "12:15",
    time: "11:45 - 12:15",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 8,
    start: "12:15",
    end: "12:45",
    time: "12:00 - 12:45",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 9,
    start: "12:45",
    end: "13:15",
    time: "12:00 - 13:15",
    length: "30",
    type: "BREAK",
    booked: false,
  },
  {
    id: 10,
    start: "13:15",
    end: "13:45",
    time: "13:15 - 13:45",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 11,
    start: "13:45",
    end: "14:15",
    time: "13:45 - 14:15",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 12,
    start: "14:15",
    end: "14:45",
    time: "14:15 - 14:45",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 13,
    start: "14:45",
    end: "15:15",
    time: "14:45 - 15:15",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 14,
    start: "15:15",
    end: "15:30",
    time: "15:15 - 15:30",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 15,
    start: "15:30",
    end: "16:00",
    time: "15:30 - 16:00",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 16,
    start: "16:00",
    end: "16:30",
    time: "16:00 - 16:00",
    length: "30",
    type: "SLOT",
    booked: false,
  },
  {
    id: 17,
    start: "16:30",
    end: "17:00",
    time: "16:30 - 17:00",
    length: "30",
    type: "SLOT",
    booked: false,
  },
];
export const thirtyFiveMinuteSlots = [
  {
    id: 1,
    start: "09:00",
    end: "09:35",
    time: "09:00 - 09:35",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 2,
    start: "09:35",
    end: "10:10",
    time: "09:30 - 10:10",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 3,
    start: "10:10",
    end: "10:45",
    time: "10:00 - 10:45",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 4,
    start: "10:45",
    end: "11:00",
    time: "10:45 - 11:00",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 5,
    start: "11:00",
    end: "11:35",
    time: "11:00 - 11:35",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 6,
    start: "11:35",
    end: "12:10",
    time: "11:35 - 12:10",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 7,
    start: "12:10",
    end: "12:45",
    time: "12:10 - 12:45",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 8,
    start: "12:45",
    end: "13:15",
    time: "12:45 - 13:15",
    length: "30",
    type: "BREAK",
    booked: false,
  },
  {
    id: 9,
    start: "12:45",
    end: "13:20",
    time: "12:45 - 13:20",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 10,
    start: "13:20",
    end: "13:55",
    time: "13:20 - 13:55",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 11,
    start: "13:55",
    end: "14:30",
    time: "13:55 - 14:30",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 12,
    start: "14:30",
    end: "14:45",
    time: "14:30 - 14:45",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 13,
    start: "14:45",
    end: "15:20",
    time: "14:45 - 15:20",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 14,
    start: "15:20",
    end: "15:55",
    time: "15:20 - 15:55",
    length: "35",
    type: "SLOT",
    booked: false,
  },
  {
    id: 15,
    start: "15:55",
    end: "16:30",
    time: "15:55 - 16:30",
    length: "35",
    type: "SLOT",
    booked: false,
  },
];
export const fortyfiveMinuteSlots = [
  {
    id: 1,
    start: "09:00",
    end: "09:45",
    time: "09:00 - 09:45",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 2,
    start: "09:45",
    end: "10:30",
    time: "09:45 - 10:30",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 3,
    start: "10:30",
    end: "10:45",
    time: "10:30 - 10:45",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 4,
    start: "10:45",
    end: "11:30",
    time: "10:45 - 11:30",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 5,
    start: "11:30",
    end: "12:15",
    time: "11:30 - 12:15",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 6,
    start: "12:15",
    end: "12:45",
    time: "12:15 - 12:45",
    length: "30",
    type: "BREAK",
    booked: false,
  },
  {
    id: 7,
    start: "12:45",
    end: "13:30",
    time: "12:45 - 13:30",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 8,
    start: "13:30",
    end: "14:15",
    time: "13:30 - 14:15",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 9,
    start: "14:15",
    end: "14:30",
    time: "14:15 - 14:30",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 10,
    start: "14:30",
    end: "15:15",
    time: "14:30 - 15:15",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 11,
    start: "15:15",
    end: "16:00",
    time: "15:15 - 16:00",
    length: "45",
    type: "SLOT",
    booked: false,
  },
];
export const fortyfiveMinuteSlotsWithBlood = [
  {
    id: 1,
    start: "08:00",
    end: "09:00",
    time: "08:00 - 09:00",
    length: "60",
    type: "BLOOD",
    booked: false,
  },
  {
    id: 2,
    start: "10:00",
    end: "10:45",
    time: "10:00 - 10:45",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 3,
    start: "10:45",
    end: "11:30",
    time: "10:45 - 11:30",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 4,
    start: "11:30",
    end: "11:45",
    time: "11:30 - 11:45",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 5,
    start: "11:45",
    end: "12:30",
    time: "11:45 - 12:30",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 6,
    start: "12:30",
    end: "13:15",
    time: "12:30 - 13:15",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 7,
    start: "13:15",
    end: "13:45",
    time: "13:15 - 13:45",
    length: "30",
    type: "BREAK",
    booked: false,
  },
  {
    id: 8,
    start: "13:45",
    end: "14:30",
    time: "13:45 - 14:30",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 9,
    start: "14:30",
    end: "15:15",
    time: "14:30 - 15:15",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 10,
    start: "15:15",
    end: "15:30",
    time: "15:15 - 15:30",
    length: "15",
    type: "BREAK",
    booked: false,
  },
  {
    id: 11,
    start: "15:30",
    end: "16:15",
    time: "15:30 - 16:15",
    length: "45",
    type: "SLOT",
    booked: false,
  },
  {
    id: 12,
    start: "16:15",
    end: "17:00",
    time: "16:15 - 17:00",
    length: "45",
    type: "SLOT",
    booked: false,
  },
];
export const hourSlots = [
  {
    id: 1,
    start: "09:00",
    end: "10:00",
    time: "09:00 - 10:00",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 2,
    start: "10:00",
    end: "10:15",
    time: "10:00 - 10:15",
    length: 15,
    type: "BREAK",
    booked: 0,
  },
  {
    id: 3,
    start: "10:15",
    end: "11:15",
    time: "10:15 - 11:15",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 4,
    start: "11:15",
    end: "12:15",
    time: "11:15 - 12:15",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 5,
    start: "12:15",
    end: "12:45",
    time: "12:15 - 12:45",
    length: 30,
    type: "BREAK",
    booked: 0,
  },
  {
    id: 6,
    start: "12:45",
    end: "13:45",
    time: "12:45 - 13:45",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 7,
    start: "13:45",
    end: "14:45",
    time: "13:45 - 14:45",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 8,
    start: "14:45",
    end: "15:00",
    time: "14:45 - 15:00",
    length: 15,
    type: "BREAK",
    booked: 0,
  },
  {
    id: 9,
    start: "15:00",
    end: "16:00",
    time: "15:00 - 16:00",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
];
export const hourSlotsWithBlood = [
  {
    id: 1,
    start: "08:00",
    end: "09:00",
    time: "08:00 - 09:00",
    length: 60,
    type: "BLOOD",
    booked: 0,
  },
  {
    id: 2,
    start: "09:00",
    end: "10:00",
    time: "09:00 - 10:00",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 3,
    start: "10:00",
    end: "10:15",
    time: "10:00 - 10:15",
    length: 15,
    type: "BREAK",
    booked: 0,
  },
  {
    id: 4,
    start: "10:15",
    end: "11:15",
    time: "10:15 - 11:15",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 5,
    start: "11:15",
    end: "12:15",
    time: "11:15 - 12:15",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 6,
    start: "12:15",
    end: "12:45",
    time: "12:15 - 12:45",
    length: 30,
    type: "BREAK",
    booked: 0,
  },
  {
    id: 7,
    start: "12:45",
    end: "13:45",
    time: "12:45 - 13:45",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 8,
    start: "13:45",
    end: "14:45",
    time: "13:45 - 14:45",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
  {
    id: 9,
    start: "14:45",
    end: "15:00",
    time: "14:45 - 15:00",
    length: 15,
    type: "BREAK",
    booked: 0,
  },
  {
    id: 10,
    start: "15:00",
    end: "16:00",
    time: "15:00 - 16:00",
    length: 60,
    type: "SLOT",
    booked: 0,
  },
];